import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { AppRouteGuard } from "@shared/auth/auth-route-guard";
import { HomePage } from "./home/home.page";
import { CertificationPage } from "./certification/certification.page";
import { FarmersPage } from "./farmers/farmers.page";
import { FarmerPage } from "./farmer/farmer.page";
import { UsersPage } from "./users/users.page";
import { UserPage } from "./user/user.page";
import { VerificationsPage } from "./verifications/verifications.page";
import { VerificationPage } from "./verification/verification.page";
import { CertificationScorePage } from "./certification-score/certification-score.page";
import { DashboardPage } from "./dashboard/dashboard.page";
import { AdminPage } from "./admin/admin.page";
import { PrivacyPage } from "./privacy/privacy.page";
import { PrivateDataPage } from "./privacy/private-data.page";

export const MainRoutingModule_routes: Routes = [
  {
    path: "",
    redirectTo: "home",
    pathMatch: "full",
  },
  // {
  //   path: 'account/login',
  //   component: LoginPage
  // },
  // {
  //   path: 'account/register',
  //   component: RegisterPage
  // },
  {
    path: "home",
    component: HomePage,
  },
  {
    path: "certification",
    component: CertificationPage,
    // canActivate: [AppRouteGuard],
    data: {
      permission: "Pages.Certification",
    },
  },
  {
    path: "certification-score",
    component: CertificationScorePage,
    // canActivate: [AppRouteGuard],
    data: {
      permission: "Pages.Certification",
    },
  },
  {
    path: "farmers",
    component: FarmersPage,
    // canActivate: [AppRouteGuard],
    data: {
      permission: "Pages.Farmers",
    },
  },
  {
    path: "farmer",
    component: FarmerPage,
    // canActivate: [AppRouteGuard],
    data: {
      permission: "Pages.Farmer",
    },
  },
  {
    path: "users",
    component: UsersPage,
    // canActivate: [AppRouteGuard],
    data: {
      permission: "Pages.Users",
    },
  },
  {
    path: "user",
    component: UserPage,
    // canActivate: [AppRouteGuard],
    data: {
      permission: "Pages.User",
    },
  },
  {
    path: "verifications",
    component: VerificationsPage,
    // canActivate: [AppRouteGuard],
    data: {
      permission: "Pages.Verifications",
    },
  },
  {
    path: "verification",
    component: VerificationPage,
    // canActivate: [AppRouteGuard],
    data: {
      permission: "Pages.Verification",
    },
  },
  {
    path: "dashboard",
    component: DashboardPage,
    data: {
      permission: "Role.Admin",
    },
  },
  {
    path: "admin",
    component: AdminPage,
    data: {
      permission: "Role.Admin",
    },
  },
  { path: "privacy", component: PrivacyPage },
  { path: "private-data", component: PrivateDataPage },
];
